/* ==========================================================================
   Stránkování Boost („Page links") jako skutečné odkazy <a href="?page=N">
   – kvůli SEO: Google prochází jen odkazy, Boost vykresluje <button> bez adresy.

   Jak to funguje: tlačítka čísel a šipek se nahradí odkazy se stejnými třídami
   a atributy. Boost klik obsluhuje podle třídy cíle (filter.module.js 1.88.2:
   classList.contains("boost-sd__pagination-number" / "-button")), takže stránku
   dál načte sám bez reloadu (ikona šipky má v CSS Boostu pointer-events:none,
   cílem kliku je tedy vždy odkaz). Výchozí navigaci odkazu zastavíme
   (preventDefault, NE stopPropagation – Boost klik musí dostat). Cmd/Ctrl/Shift
   +klik necháme prohlížeči (nová záložka/okno) a Boostu ho nepustíme; kolečko
   myši vyvolá auxclick, ten Boost neřeší a funguje nativně.

   Jen na kolekcích: /search má X-Robots-Tag noindex,nofollow – odkazy by tam
   SEO nic nepřinesly. Nepřevádí se aktivní stránka a „…". Když Boost aktivní
   číslo nevykreslí (?page za koncem výpisu), šipky zůstanou tlačítky – jejich
   cíl by nešel spolehlivě určit.
   Po aktualizaci Boostu ověřit, že se tlačítka dál převádějí (šablona lišty).
   ========================================================================== */
(function () {
  'use strict';

  var SEL_PG = '.boost-sd__pagination';
  var SEL_BTN = 'button.boost-sd__pagination-number, ' +
                'button.boost-sd__pagination-button--prev, ' +
                'button.boost-sd__pagination-button--next';

  function aktualni(pg) {
    var a = pg.querySelector('.boost-sd__pagination-number--active');
    return a ? parseInt(a.textContent, 10) || 0 : 0;
  }

  function adresa(p) {
    var u = new URL(window.location.href);
    if (p <= 1) u.searchParams.delete('page'); else u.searchParams.set('page', p);
    return u.pathname + u.search;
  }

  function prevest(pg) {
    if (pg.closest('.boost-sd__search-result-panel-content')) return;   // záložky ve vyhledávání
    var cur = aktualni(pg);
    var tlacitka = pg.querySelectorAll(SEL_BTN);
    for (var i = 0; i < tlacitka.length; i++) {
      var b = tlacitka[i];
      var cls = b.className;
      if (/--active|--disabled/.test(cls)) continue;
      if (!cur && /--prev|--next/.test(cls)) continue;
      var p = /--prev/.test(cls) ? cur - 1
            : /--next/.test(cls) ? cur + 1
            : parseInt(b.textContent, 10);
      if (!(p >= 1)) continue;
      var a = document.createElement('a');
      for (var j = 0; j < b.attributes.length; j++) {
        var at = b.attributes[j];
        if (at.name !== 'type') a.setAttribute(at.name, at.value);
      }
      a.setAttribute('data-tipa-page', p);
      a.setAttribute('href', adresa(p));
      a.innerHTML = b.innerHTML;
      b.replaceWith(a);
    }
  }

  function vse() {
    if (window.location.pathname.indexOf('/collections/') === -1) return;
    var pgs = document.querySelectorAll(SEL_PG);
    for (var i = 0; i < pgs.length; i++) prevest(pgs[i]);
  }

  /* Adresu obnovit těsně před použitím: Boost může lištu překreslit dřív, než
     přepíše URL (filtr, řazení) – nová záložka by jinak dostala starý filtr. */
  function obnovit(e) {
    var a = e.target.closest && e.target.closest(SEL_PG + ' a[data-tipa-page]');
    if (a) a.setAttribute('href', adresa(+a.getAttribute('data-tipa-page')));
  }
  document.addEventListener('pointerdown', obnovit, true);
  document.addEventListener('focusin', obnovit, true);

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest(SEL_PG + ' a[href]');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) {            // Alt ne – v Chrome by stáhl soubor
      e.stopPropagation();                                 // nová záložka; Boost ať stránku nemění
      return;
    }
    e.preventDefault();                                    // stránku načte Boost (AJAX)
  }, true);

  /* Mezerník: <button> na něj reagoval, odkaz ne – pro klávesnici zachovat */
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var a = e.target.closest && e.target.closest(SEL_PG + ' a[data-tipa-page]');
    if (!a) return;
    e.preventDefault();
    a.click();
  }, true);

  /* Boost lištu překresluje při každé změně stránky / filtru / řazení */
  var plan = null;
  new MutationObserver(function () {
    if (plan) return;
    plan = setTimeout(function () { plan = null; vse(); }, 30);
  }).observe(document.documentElement, { childList: true, subtree: true });

  vse();
})();
